const React = require("react");
const {statusesTrx} = require("./constants");

const DisplayStatusWithdraw = ({status, className: cn}) => {
  // const statusesWithdraw = [
  //   {name: 'initiated', color: '5B47FF'},
  //   {name: 'cancelled', color: '2'},
  //   {name: 'sent', color: '2CE889'}
  // ];
  const className = 'ttU fw7 c5B47FF.initiated cFF481F.cancelled c2CE889.sent'
    + (status ? ` ${status}` : '')
    + (cn ? ` ${cn}` : '');

  return <span className={className}>{status}</span>;
}


//   pending,
//   confirmation,
//   accepted,


const DisplayStatusTrx = ({status, className: cn}) => {
  // const statusesTrx = [
  //   {name: 'created', color: '5B47FF'},
  //   {name: 'pending', color: 'c73757A'},
  //   {name: 'confirmed', color: '73757A'},
  //   {name: 'accepted', color: '2CE889'},
  //   {name: 'expired', color: '73757A'},
  //   {name: 'canceled', color: 'FF481F'},
  //   {name: 'blocked', color: 'FF481F'}
  // ]
  const className = 'ttU fw7 c5B47FF.created c5B47FF.sent cEE82EE.initated cFFCC18.pending cFF7F23.confirmation c2CE889.accepted c73757A.expired cFF481F.cancelled cFF481F.blocked'
    + (status ? ` ${status}` : '')
    + (cn ? ` ${cn}` : '');

  // initiated & sent are the statuses of chargeback operations
  // we don't show them... yet
  // const text = ['initiated', 'sent'].includes(status) ? '-' : status;
  const text = status ? status : '-';

  return <span className={className}>{text}</span>;
}

const DisplayStatusChargeback = ({status, className: cn}) => {
  // const statusesTrx = [
  //   {name: 'created', color: '5B47FF'},
  //   {name: 'pending', color: 'c73757A'},
  //   {name: 'sent', color: '2CE889'}
  //   {name: 'cancelled', color: 'FF481F'},
  // ]
  const className = 'ttU fw7 c5B47FF.created cFFCC18.pending c2CE889.sent cFF481F.cancelled'
    + (status ? ` ${status}` : '')
    + (cn ? ` ${cn}` : '');

  return <span className={className}>{status}</span>;
}

module.exports = {
  DisplayStatusWithdraw,
  DisplayStatusTrx,
  DisplayStatusChargeback
}
